module.exports = __webpack_public_path__ + "static/media/flight_booking.a73969e3.svg";